import { styled } from 'styled-components';
import { palette } from '@/constants/styles.ts';
import ChevronIcon from '@/assets/images/chevron.svg?react';

export const Container = styled.div`
	position: relative;
	font-size: 14px;
	font-weight: 100;

	&:focus ul {
		display: block;
	}

	ul {
		display: none;
	}
`;

export const CurrentSelection = styled.div`
	display: flex;
	align-items: center;
	cursor: pointer;
`;

export const PartnerDetails = styled.div`
	display: flex;
	align-items: center;
`;

export const Chevron = styled(ChevronIcon)`
	margin-left: 5px;
	cursor: pointer;
`;

export const Menu = styled.ul`
	position: absolute;
	list-style: none;
	width: 254px;
	background: ${palette.white};
	border: 1px solid ${palette.primaryGray};
	max-height: 80dvh;
	overflow-y: auto;
`;

export const MenuItem = styled.li`
	padding: 4px 10px;
	cursor: pointer;

	&:hover {
		background: ${palette.primaryColor};
		color: ${palette.white};
	}
`;

export const MenuSeparator = styled.li`
	height: 1px;
	background: ${palette.primaryGray};
	margin: 4px 0;
`;

export const PartnerLogoImage = styled.img`
	width: 28px;
	height: 28px;
	object-fit: contain;
`;

export const PartnerLogoAlt = styled.div`
	width: 28px;
	height: 28px;
	border-radius: 50px;
	color: ${palette.white};
	background: ${palette.darkGray};
	text-transform: capitalize;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 18px;
	padding-top: 3px;
`;

export const PartnerLabel = styled.div`
	margin-left: 10px;
`;
